import * as React from "react";

interface OwnProps {
    filter: React.JSX.Element;
    cards: React.JSX.Element;
    className?: string;
    children: React.ReactNode;
    numberOfTriageTasks?: number;
}

const TriageList: React.FunctionComponent<OwnProps> = (props: OwnProps) => {
    return (
        <div className={props.className}>
            <div className="triage-list">
                <div className="triage-filter">
                    {props.filter}
                </div>
                {props.numberOfTriageTasks !== undefined && props.numberOfTriageTasks >= 0 &&
                    <div className="triage-task-summary">
                        <p>Total Tasks: {props.numberOfTriageTasks}</p>
                    </div>}
                {props.cards}
            </div>
            <div className="triage-detail-column">
                {props.children}
            </div>
        </div>
    );
};

export { TriageList };
